const CHART_SIM_PROVIDERS = {
    WIRELESS_LOGIC: {
        name: 'SIM service',
        key: 'Wireless Logic'
    },
    BOUYGUES_TELECOM: {
        name: 'Bouygues Telecom',
        key: 'Bouygues Telecom'
    },
    SIERRA_WIRELESS: {
        name: 'Sierra Wireless',
        key: 'Sierra Wireless Ingenico'
    },
    DEUTSCHE_TELEKOM: {
        name: 'Deutsche Telekom',
        key: 'DEUTSCHE_TELEKOM'
    }
};

export default CHART_SIM_PROVIDERS;